/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class ExternalInvoiceOrderListVoModel extends JSONable{
  uuid: string | undefined = undefined;
  serviceProviderOrderUuid: string | undefined = undefined;
  createdAt: string | undefined = undefined;
  orderNumber: string | undefined = undefined;
  price: string | undefined = undefined;
  currencyCode: string | undefined = undefined;
  paymentTimeLimit: number | undefined = undefined;
}
